export default "__VITE_ASSET__CbhKP847__"